<button
  (click)="_onButtonClick()"
  type="button"
  class="button-toggle"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
